import { Component, Input } from '@angular/core';
import { AppointmentService } from '../services/appointment.service';
import { Appointment } from '../models/appointment.model';
import { LookupService } from '../services/lookup.service';
import { NotificationService } from '../services/notification.service';
import { DatePipe } from '@angular/common';
import * as $ from 'jquery';
import { PatientService } from '../services/patient.service';
import { Patient } from '../models/patient.model';

import { RoleService } from '../services/role.service';
import { Privilege } from '../models/privilege.model';

@Component({
  selector: 'app-appointment-form',
  templateUrl: './appointment-form.component.html'
})
export class AppointmentFormComponent {
  constructor(private roleService: RoleService, public lookupService: LookupService, public patientService: PatientService, public service: AppointmentService, private notificationService: NotificationService, private datepipe: DatePipe) { }

  @Input() model: Appointment;

  options: any = { format: 'YYYY-MM-DD', minDate: new Date() };
  optionsTime: any = { format: 'LT' };
  filter: string;

  sponsorID: any=null;
  membershipID: any;
  membershipTypeName: any;
  sponsorName: any;

  ngOnInit() {
    this.lookupService.getStates();
    this.lookupService.getGenders();
    this.lookupService.getSpecializations();
    this.lookupService.getStaffs();
    this.lookupService.getSponsors();

    if (this.roleService.isAuthorized(Privilege.Admin))
      this.options = { format: 'YYYY-MM-DD' }
  }

  onPatientChanged(data: { value: string[] }): void {
    if (!data)
      return;

    this.patientService.get(data).subscribe(
      res => {
        var patient = res as Patient;

        this.model.stateID = patient.stateID;
        this.lookupService.getCitiesByState(patient.stateID);
        this.model.cityID = patient.cityID;

        this.sponsorID = patient.stateID;
        this.membershipID = patient.membershipID;
        this.membershipTypeName = patient.membershipTypeName;
        this.sponsorName = patient.sponsorName;
      },
      err => { console.log(err); this.notificationService.notifyFailure(); }
    );
  }

  filterPatient() {
    var term = $('#Filter').val();
    if (term.toString().length >= 3)
      this.lookupService.filterPatient(term);
  }

  getCitiesByState(id) {
    this.lookupService.getCitiesByState(id);
  }

  onStateChanged(data: { value: string[] }): void {
    this.getCitiesByState(data);
  }

  submitted = false;

  onSubmit() {
    this.submitted = true;
    this.model.appointmentTime = this.datepipe.transform(this.model.appointmentTime, 'HH:mm');

    this.service.model = this.model;
    if (!this.model.appointmentID)
      this.insertRecord();
    else
      this.updateRecord();
  }


  insertRecord() {

    this.service.post().subscribe(
      res => {
        this.notificationService.notifySuccess();
        this.service.search();
        $('#PanelForm, #PanelMain').slideToggle();
      },
      err => { console.log(err); }
    )
  }

  updateRecord() {

    this.service.put().subscribe(
      res => {
        this.notificationService.notifySuccess();
        this.service.search();
        $('#PanelForm, #PanelMain').slideToggle();
      },
      err => {
        console.log(err);
      }
    )
  }


}
 
